import {
  EmployeeGoal,
  GoalStatus,
  GoalsPerStatus,
} from '../models/GoalsInterfaces';

export const goalsMapperPerStatus = (goals: EmployeeGoal[]): GoalsPerStatus => {
  return goals.reduce(
    (acc, goal) => {
      if (goal.statuscode === GoalStatus.DRAFT) {
        acc.draft.push(goal);
        return acc;
      }
      if (goal.statuscode === GoalStatus.APPROVED) {
        acc.approved.push(goal);
        return acc;
      }
      if (goal.statuscode === GoalStatus.IN_PROGRESS) {
        acc.inProgress.push(goal);
        return acc;
      } else {
        acc.closed.push(goal);
        return acc;
      }
    },
    {
      draft: [],
      approved: [],
      inProgress: [],
      closed: [],
    }
  );
};
